const FOUNDATION_CLASS = [
  "Any",
  "Binding",
  "Topic",
  "Term",
  "Actor",
  "Asset",
  "PlaybookRule",
  "Role",
  "Document",
  "Action",
  "Playbook",
  "InfoPack",
  "Agreement",
  "Guidance",
  "FirstPartyRole",
  "ThirdPartyRole",
  "Obligation",
  "Definition",
  "ConditionalTerm",
  "Group",
  "NonDisclosureAgreement",
  "ConditionSubsequent",
  "ConditionPrecedent",
];

export default FOUNDATION_CLASS;

export const clientUrlOptions = [
  {
    value: "https://mattersmith5.embeddedexperience.com/",
    label: "https://mattersmith5.embeddedexperience.com/",
  },
  {
    value: "https://mattersmith6.embeddedexperience.com/",
    label: "https://mattersmith6.embeddedexperience.com/",
  },
  {
    value: "https://mattersmith7.embeddedexperience.com/",
    label: "https://mattersmith7.embeddedexperience.com/",
  },
  {
    value: "https://mattersmith8.embeddedexperience.com/",
    label: "https://mattersmith8.embeddedexperience.com/",
  },
  {
    value: "https://mattersmith10.embeddedexperience.com/",
    label: "https://mattersmith10.embeddedexperience.com/",
  },
];
